import * as React from "react";
import { AsyncActionStatus } from "../../shared/abstractStore";
import { useAsyncCallback } from "react-use-async-callback";
import { useAccountService } from "./useAccountService";
import { RegisterResult } from "./AccountService";

/**
 * Confirm an invite and set a password.
 */
export function useConfirmInviteCallback(): [(model: { password: string }) => Promise<RegisterResult>, AsyncActionStatus] {
    const accountService = useAccountService();

    // Get the details from the query string.
    const { userId, code } = React.useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        const userId = params.get('userId') ?? params.get('UserId') ?? '';
        const code = params.get('code') ?? params.get('Code') ?? '';
        return { userId, code };
    }, []);

    const [action, { isExecuting, errors }] = useAsyncCallback(async (model: { password: string }) => {
        return await accountService.confirmInvite({ userId: userId, code: code, password: model.password });
    }, [accountService, userId, code]);

    return [action, { isExecuting, errors }];
}
